import React from "react";
import parse from "html-react-parser";

interface WorkProcessProps {
  id: number | string;
  title: string;
  description: string;
  step: number | string;
  font_awesome_class?: string;
}

const WorkProcess: React.FC<WorkProcessProps> = ({
  id,
  title,
  description,
  step,
}) => {
  return (
    <div
      key={id}
      className="cht-rounded-[20px] cht-bg-white cht-border cht-border-slate-200/80 cht-shadow-soft cht-p-5 sm:cht-p-6 cht-mb-4 cht-transition-all cht-duration-300 hover:cht-border-[#3e57da]/50 hover:cht-shadow-md hover:-cht-translate-y-0.5 group"
    >
      <div className="cht-flex cht-items-start cht-gap-4">
        {/* Step Circular Indicator */}
        <div className="cht-shrink-0 cht-w-10 cht-h-10 cht-rounded-xl cht-bg-blue-50 cht-border cht-border-blue-100 cht-flex cht-items-center cht-justify-center cht-text-[#3e57da] !cht-font-heading !cht-font-bold cht-text-sm group-hover:cht-scale-110 cht-transition-transform">
          {step}
        </div>

        {/* Content */}
        <div className="cht-flex-1 cht-min-w-0">
          <div className="cht-flex cht-items-center cht-justify-between cht-gap-2 cht-mb-2">
            <h4 className="!cht-font-heading cht-text-base sm:cht-text-lg !cht-font-bold cht-text-slate-900 cht-tracking-tight cht-mb-0">
              {title}
            </h4>
            <span className="cht-inline-flex cht-items-center cht-px-2.5 cht-py-0.5 cht-bg-blue-50/80 cht-border cht-border-blue-100 cht-rounded-full cht-text-[11px] !cht-font-bold cht-text-[#3e57da]">
              Stage {step}
            </span>
          </div>

          <div className="!cht-font-body cht-text-xs sm:cht-text-sm cht-text-slate-600 cht-leading-relaxed cht-mb-0">
            {parse(`${description}`)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkProcess;

